// ----------------------------------------------------------------------------
// Проверяют видимость элемента на странице
// ----------------------------------------------------------------------------


export function isHidden(el) {
    return el && (el.offsetWidth === 0 || window.getComputedStyle(el).display === 'none');
}

export function isVisible(el) {
    return el && (el.offsetWidth > 0 || el.offsetHeight > 0)
}